import React from "react";
import DragNumberInput from "../../ui/DragNumberInput";

const SensorAttrDragField = React.memo(
  ({ label, attrKey, sensor, onUpdateAttr, step = "0.01" }) => {
    const raw = sensor.attrs?.[attrKey];
    return (
      <DragNumberInput
        label={label}
        value={raw ?? ""}
        dragValue={Number(raw) || 0}
        onChange={(e) => onUpdateAttr(sensor.uuid, { [attrKey]: e.target.value })}
        onDragValueChange={(n) => onUpdateAttr(sensor.uuid, { [attrKey]: String(n) })}
        wrapperClassName="flex flex-row items-center gap-2 min-w-0 w-full"
        labelClassName="inline-flex shrink-0 whitespace-nowrap text-xs text-gray-400"
        inputWrapperClassName="min-w-0 flex-1"
        inputClassName="w-full min-w-0 px-2 py-1 bg-gray-800 border border-gray-600 rounded text-xs text-gray-100"
        inputProps={{ step }}
      />
    );
  }
);

export default SensorAttrDragField;
